export default "__VITE_ASSET__C4TWw2nt__"